<div class="flex flex-col min-h-screen w-full overflow-x-hidden">
  @if (isLoggedIn) {
    <div class="header">
      <stine-navigation></stine-navigation>
    </div>
  }

  <main class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </main>
  @if ((!isLoggedIn && xSmallScreenSize) || !xSmallScreenSize) {
    <footer class="bg-primary text-white flex justify-center items-center px-4">
      <img
        src="../app/assets/images/mono3.png"
        height="32"
        width="32"
        class="mr-2"
        alt="Logo"
      />
      <div class="flex justify-between w-full">
        <div class="flex flex-col">
          <span><strong>Stine Seed Company</strong> | Headquarters</span>
          <span>22555 Laredo Trl. | Adel IA 50003 U.S.A.</span>
        </div>
        <div class="sm:flex items-end hidden">
          &copy; {{ currentYear }} Stine Seed Company. All rights reserved.
        </div>
      </div>
    </footer>
  }
</div>
